import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminOrganizationNewRoute, adminOrganizationViewRoute } from '@/webapp/src/lib/routes.js'
import { SectionWrapper } from '@/webapp/src/lib/sectionWrapper.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, Button, Buttons, Segment, Table } from '@/webapp/src/lib/uninty.components.js'

export const AdminOrganizationListPage = withPageWrapper({
  title: 'Организации',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
})(() => {
  return (
    <Block fcnw>
      <Segment
        title="Организации"
        size="m"
        desc={
          <Buttons>
            <Button as="a" href={adminOrganizationNewRoute.get()}>
              Новая организация
            </Button>
          </Buttons>
        }
      >
        <SectionWrapper
          useInfiniteQuery={() =>
            trpc.getOrganizationsForAdmin.useInfiniteQuery(
              {},
              {
                getNextPageParam: (lastPage) => {
                  return lastPage.nextCursor
                },
              }
            )
          }
          setProps={({ infiniteQueryResult }) => ({
            organizations: infiniteQueryResult.data?.pages.flatMap((page) => page.organizations) ?? [],
            infiniteQueryResult,
          })}
        >
          {({ organizations, infiniteQueryResult }) => {
            return (
              <Table
                records={organizations}
                href={(record) => adminOrganizationViewRoute.get({ organizationSn: record.sn })}
                columns={[
                  { heading: 'SN', body: (record) => record.sn, width: 70 },
                  { heading: 'Название', body: (record) => record.name, width: 400 },
                ]}
                loadMore={() => {
                  if (!infiniteQueryResult.isFetchingNextPage && infiniteQueryResult.hasNextPage) {
                    void infiniteQueryResult.fetchNextPage()
                  }
                }}
                hasMore={infiniteQueryResult.hasNextPage}
              />
            )
          }}
        </SectionWrapper>
      </Segment>
    </Block>
  )
})
